"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguration = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _ApplicationContext = require("../ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getConfiguration = clientId => {
  const authConfiguration = _ApplicationContext.ApplicationContext.getClientAuthConfiguration(clientId);
  if (authConfiguration !== 'undefined' && authConfiguration !== null) {
    return new Promise((resolve, reject) => {
      return resolve(authConfiguration);
    });
  }
  const request = _axios.default.create({
    baseURL: _ApplicationContext.ApplicationContext.getApiBasePath()
  });
  return request.get('/security/auth/config', {
    headers: {
      clientId
    }
  }).then(response => {
    _ApplicationContext.ApplicationContext.setClientAuthConfiguration(clientId, response.data);
    resolve(response.data);
  });
};
exports.getConfiguration = getConfiguration;
//# sourceMappingURL=AuthenticationConfiguration.js.map